import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TableWithPagination from '../common/TableWithPagination';
import usePedidos from '../../hooks/pedidos/usePedidos';
import Filtros from '../../hooks/pedidos/FiltrosPedidos';
import GreetingCard from '../../hooks/pedidos/GreetingCard';
import StatsCards from '../../hooks/pedidos/StatsCards';
import PedidoDetalle from '../dashboard/PedidoDetalle';
import { useApi } from './../../hooks/useApi';
import { Icon } from '@iconify/react';


const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return 'Buenos días';
  if (hour >= 12 && hour < 19) return 'Buenas tardes';
  return 'Buenas noches';
};

export default function Dashboard() {
  const { get, post, loading, error } = useApi();
  const { user } = useContext(AuthContext);
  const [greeting, setGreeting] = useState(getGreeting());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const token = localStorage.getItem('token');

  const { pedidos } = usePedidos( selectedDate);
  console.log(pedidos);
  // mostrar detalle 
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  
  // filtros
  const [filtroApp, setFiltroApp] = useState('');
  const [filtroEstatus, setFiltroEstatus] = useState('');

  const appsDisponibles = [...new Set(pedidos.map((p) => p.aplicacionNombre).filter(Boolean))];
  const estatusDisponibles = [...new Set(pedidos.map((p) => p.estatus).filter(Boolean))];

  const pedidosFiltrados = pedidos.filter(
    (p) =>
      (filtroApp === '' || p.aplicacionNombre === filtroApp) &&
      (filtroEstatus === '' || p.estatus === filtroEstatus)
  );

  const columns = [
    { header: 'Aplicación', accessor: 'aplicacionNombre' },
    { header: 'Documento', accessor: 'documentoClase'},
    { header: 'SAP ID', accessor: 'salesSAP' },
    { header: 'Cliente Referencia', accessor: 'clienteReferencia' },
    { header: 'Fecha', accessor: 'createdAt' },
    { header: 'Destinatario Rol', accessor: 'rolDestinatario' },
    { header: 'Metodo Pago', accessor: 'metodoPago' },
    { header: 'Estatus', accessor: 'estatus' },
    { header: 'Productos', accessor:'totalProductos'},
  ];

  // panel detalle
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const handleView = async (pedido) => {
    setLoadingDetalle(true);
    const pedidoId = pedido.id;
    try {
      const data = await get('detallePedido', { urlParams: { id: pedidoId } });
      setPedidoSeleccionado(data);
    } catch (error) {
      console.error('Error al cargar el detalle del pedido:', error);
    } finally {
      setLoadingDetalle(false);
    }
  };

  const handleBack = () => {
    setPedidoSeleccionado(null);
  };


  useEffect(() => {
    const interval = setInterval(() => {
      setGreeting(getGreeting());
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const CustomDateButton = React.forwardRef(({ value, onClick }, ref) => (
    <button
      type="button"
      onClick={onClick}
      ref={ref}
      className="flex items-center gap-2 px-4 py-2 bg-white text-slate-700 dark:bg-slate-700 dark:text-white rounded-md border border-gray-300 focus:outline-none"
    >
      <Icon icon="mdi:calendar" className="w-5 h-5 text-slate-500" />
      <span>{value || 'Seleccione una fecha'}</span>
    </button>
  ));

  return (
    <div className="p-4">
      {/*
          <div className="flex justify-end flex-wrap items-center mb-6">
            <div className="flex sm:space-x-4 space-x-2 sm:justify-end items-center rtl:space-x-reverse">
              <label className="font-bold">Información del día </label>
              <div className="relative">
                
              </div>
            </div>
          </div> */}
          
          <div className="grid grid-cols-12 gap-5 mb-5">
            {/*<div className="2xl:col-span-3 lg:col-span-3 col-span-12">
              <GreetingCard greeting={greeting} userName={user.nombre} />
            </div> */}
            <div className="2xl:col-span-9 lg:col-span-9 col-span-12">
              <StatsCards
                fecha={selectedDate}
                token={token}
                onCardClick={(estatus) => setFiltroEstatus(estatus)}
                endpoint = 'PedidoExt'
              />
            </div>
          </div>
          {!pedidoSeleccionado ? (
            <>
          <div className="grid grid-cols-12 gap-5">
            <div className="xl:col-span-12 col-span-12">
              <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <div className="p-6">
                  <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
                    {/* DatePicker individual */}
                    <div className="flex items-center gap-2">
                      <label className="text-sm font-medium text-slate-600">Fecha:</label>
                      <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        customInput={<CustomDateButton />}
                        calendarClassName="!z-50"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>

                    {/* Filtros múltiples en bloque responsivo */}
                    <div className="flex flex-wrap items-center gap-4">
                      <Filtros
                        filtroApp={filtroApp}
                        setFiltroApp={setFiltroApp}
                        appsDisponibles={appsDisponibles}
                        filtroEstatus={filtroEstatus}
                        setFiltroEstatus={setFiltroEstatus}
                        estatusDisponibles={estatusDisponibles}
                      />
                    </div>
                  </div>

                  {/*}
                  <div className="flex justify-start flex-wrap items-center mb-6">
                    <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        className="btn bg-white text-slate-700 dark:bg-slate-700 dark:text-white !font-normal cursor-pointer px-4 py-2 rounded-md focus:outline-none"
                        calendarClassName="!z-50"
                        dateFormat="dd/MM/yyyy"
                      />
                      <Filtros
                        filtroApp={filtroApp}
                        setFiltroApp={setFiltroApp}
                        appsDisponibles={appsDisponibles}
                        filtroEstatus={filtroEstatus}
                        setFiltroEstatus={setFiltroEstatus}
                        estatusDisponibles={estatusDisponibles}
                      />
                  </div> */}
                  <div className="overflow-x-auto">
                    <TableWithPagination
                      columns={columns}
                      data={pedidosFiltrados}
                      onView={handleView}
                      showView={true}
                      showEdit={false}
                      showDelete={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          </>
      ) : (
        <PedidoDetalle pedido={pedidoSeleccionado} onBack={handleBack} loading={loadingDetalle} />
      )}
    </div>
  );
}
